export default {
  transactionBatchPurchaseApprove: require('./transactionBatchPurchaseApprove')
    .default,
  transactionBatchPurchaseDisapprove: require('./transactionBatchPurchaseDisapprove')
    .default,
  transactionBatchPurchaseDisapproveWithReason: require('./transactionBatchPurchaseDisapproveWithReason')
    .default,
  ApprovePrescription: require('./ApprovePrescription').default,
  DisapprovePrescription: require('./DisapprovePrescription').default,
  transactionCodeFreeGoodApprove: require('./transactionCodeFreeGoodApprove')
    .default,
  transactionBatchFreeGoodFLLApprove: require('./transactionBatchFreeGoodFLLApprove')
    .default,
  transactionBatchFreeGoodFLLDisapprove: require('./transactionBatchFreeGoodFLLDisapprove')
    .default,
  userActivateDeactivate: require('./userActivateDeactivate.tsx').default,
  updateCustomerDetails: require('./updateCustomerDetails.tsx').default,
  updateUserDetails: require('./updateUserDetails.tsx').default,
  voidTransaction: require('./voidTransaction.tsx').default,
  extendTransactionCode: require('./extendTransactionCode.tsx').default,
  carryOverTransaction: require('./carryOverTransaction.tsx').default,
  addProgram: require('./addProgram').default,
  logout: require('./logout').default,
  settings: require('./settings').default,
  hkapiReportExport: require('./hkapiReportExport').default,
  BpDeliveryButton: require('./sanofi-my/bpDelivery').default,
  optoutButton: require('./sanofi-my/optoutButton').default,
  exportTable: require('./exportTable').default,
  updateLineItem: require('./updateLineItem.jsx').default,
  updateOverallPatientDetails: require('./updateOverallPatientDetails.jsx').default,
  chasCardApproval: require('./chasCardApproval.jsx').default,
  addHCP: require('./addHCP').default,
  extendTransactionCode: require('./extendTransactionCode.tsx').default,
  sendPrefilledLink:  require('./sendPrefilledLink.tsx').default,
  updateFreeGoodDeliveryStatus:  require('./updateFreeGoodDeliveryStatus').default,
  updateManualForm: require('./uploadManualForm').default,
  preApprovalScheme: require('./preApprovalScheme').default,
  uploadUtilizationForm: require('./uploadUtilizationForm').default,
  resendCode: require('./resendCode.tsx').default,
  mycareApproveSelfEnrolledPatient: require('./mycare/approveSelfEnrolledPatient').default,
  approveSelfEnrolledPatient: require('./selfEnrollment/approveSelfEnrolledPatient').default,
  rejectSelfEnrolledPatient: require('./selfEnrollment/rejectSelfEnrolledPatient').default,
  cancelSelfEnrolledPatient: require('./selfEnrollment/cancelSelfEnrolledPatient').default,
  editSelfEnrolledPatient: require('./selfEnrollment/editSelfEnrolledPatient').default,
  gskUpdateCustomerDetails: require('./gsk-onecare/updateCustomerDetails').default,
  prescriptionDetails: require('./gsk-onecare/prescriptionDetails').default,
  approveFreeBox: require('./freeBoxStatusAction/approveFreeBox').default,
  validateEligibility: require('./freeBoxStatusAction/validateEligibility').default,
  markFreeBoxAsProcessing: require('./freeBoxStatusAction/markFreeBoxAsProcessing').default,
  freeBoxDeliveredAtPharmacy: require('./freeBoxStatusAction/freeBoxDeliveredAtPharmacy').default,
  cancelEligibility: require('./freeBoxStatusAction/cancelEligibility').default,
  resendVoucherCode: require('./resendVoucherCode').default,
  updateVoucherRedemptionDate: require('./updateVoucherRedeemedDate').default,
  sybravaUpdateCustomerDetails: require('./sybrava-my/updateCustomerDetails.tsx').default,
  resendCodeCycle: require('./cycleAction/resendCode').default,
  markAsRedeemedCycle: require('./cycleAction/markAsRedeemed').default,
  updateCycle: require('./cycleAction/updateCycle').default,
  deleteCycle: require('./cycleAction/deleteCycle').default,
  addCycles: require('./cycleAction/addCycle').default,
  optOutPatient: require('./optOutAction').default,
  cancelPatient: require('./cancelPatientAction').default,
  optOutPatientAction: require('./optOutPatientAction').default,
  lgsUpdateLineItem: require('./lgs/updateLineItem').default,
  markCodeAsRedeemed: require('./markCodeAsRedeemed').default,
  updateVoucherRedemption: require('./updateVoucherRedemption').default,
};
